import { fetchAndCacheBlob } from '../data/db/media-cache'
import { loadNextAd } from '../player/player'
import { sampleVast } from '../samples/vast'
import { parseVast } from '../utils/vast'
import {
  hideLoadingSpinner,
  showImageElement,
  showLoadingSpinner,
  showVastElement,
  showVideoElement
} from './display'
import { clearVideoElement, getElement } from './dom'
import { handleImageEvent, handleVastEvent, handleVideoEvent } from './event'

// Global logger reference that will be set from index.js
let globalLogger = null

// Function to set global logger from index.js
export const setGlobalLoggerInHandlers = (logger) => {
  globalLogger = logger
}

export const handleVideoContent = async (adData) => {
  const url = adData.url
  const extension = url?.split('.').pop()?.toLowerCase()
  const validExtensions = ['mp4', 'webm', 'ogg']

  if (!validExtensions.includes(extension)) {
    console.warn('Invalid video extension. Reloading...')
    window.location.reload()
    return
  }

  showLoadingSpinner()
  const videoElem = showVideoElement()
  handleVideoEvent(videoElem, adData)

  try {
    const blob = await fetchAndCacheBlob(url)
    const newSource = URL.createObjectURL(blob)
    const sourceElem = document.createElement('source')
    sourceElem.src = newSource
    sourceElem.type = `video/${extension}`
    videoElem.appendChild(sourceElem)
    videoElem.load()
    hideLoadingSpinner()
  } catch (error) {
    console.error('Failed to load video:', error)
    hideLoadingSpinner()
  }
}

export const handleImageContent = async (adData) => {
  showLoadingSpinner()
  const imageElem = showImageElement()
  handleImageEvent(imageElem, adData)

  try {
    const blob = await fetchAndCacheBlob(adData.url)
    imageElem.src = URL.createObjectURL(blob)
    hideLoadingSpinner()
  } catch (error) {
    console.error('Failed to load image:', error)
    hideLoadingSpinner()
  }
}

export const handleVastContent = async (adData) => {
  showLoadingSpinner()
  const mediaElement = showVastElement()
  handleVastEvent(mediaElement, adData)

  try {
    const mediaUrl = parseVast(adData.url, false)
    if (!mediaUrl) {
      loadNextAd()
      console.error('Invalid media URL')
      return
    }
    const blob = await fetchAndCacheBlob(mediaUrl)
    const newSource = URL.createObjectURL(blob)

    let mimeType = ''
    if (/\.(webm)$/i.test(mediaUrl)) {
      mimeType = 'video/webm'
    } else if (/\.(mp4)$/i.test(mediaUrl)) {
      mimeType = 'video/mp4'
    }

    if (mimeType !== '') {
      const source = document.createElement('source')
      source.src = newSource
      source.type = mimeType
      mediaElement.appendChild(source)
    } else {
      mediaElement.src = newSource
    }

    mediaElement.load()
    hideLoadingSpinner()
  } catch (error) {
    console.error('Failed to load VAST content:', error)
    hideLoadingSpinner()
  }
}

export const clearMediaElements = () => {
  const videoElem = getElement('video-content')
  const vastElement = getElement('mediaElement')
  const imageElem = getElement('image-content')

  clearVideoElement(videoElem)
  clearVideoElement(vastElement)

  if (imageElem) {
    imageElem.removeAttribute('src')
  }
}

export function loadContent(adData) {
  clearMediaElements()
  try {
    if (!adData) {
      return handleVastContent(sampleVast)
    }
    if (adData.type === 'vastTag') {
      return handleVastContent(adData)
    }
    if (adData.type === 'video') {
      return handleVideoContent(adData)
    }
    if (adData.type === 'image') {
      return handleImageContent(adData)
    }
    return handleVastContent(sampleVast)
  } catch (e) {
    console.error('loadContent error', e)
    handleVastContent(sampleVast)
  }
}
